import React from 'react'

export default function Check(props) {
  return (
    <svg width={props.width ? props.width : "18"} height={props.height ? props.height : "18"} viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0.643066 10.9929L4.15307 15.5057C4.27151 15.6596 4.42327 15.7847 4.59696 15.8716C4.77065 15.9584 4.96175 16.0048 5.15592 16.0071C5.34697 16.0095 5.53611 15.969 5.70959 15.889C5.88306 15.8089 6.03651 15.6911 6.15878 15.5443L17.3574 1.99292" stroke="black" strokeOpacity="0.8" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}
